<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">DELETE '{{ userData.username.toUpperCase() }}'</p>
    </header>
    <section class="modal-card-body">
      <p>Are you absolutely sure? This action <b>cannot</b> be undone.<br/>Please type <b>delete</b> to confirm.</p>
      <b-field label="Confirmation" class="mt-5">
        <b-input
          v-model="confirmation"
          required>
        </b-input>
      </b-field>
      <div class="columns mt-5">
        <div class="column is-6 is-offset-6 buttons">
          <b-button
            label="Cancel"
            type="is-primary"
            @click="$emit('close')" />
          <b-button
            label="Submit"
            type="is-danger"
            @click="submit"
            :disabled="'delete' !== confirmation" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { deleteUser } from '@/api/users'
export default {
  props: {
    userData: {
      type: Object
    }
  },
  data: () => ({
    confirmation: ''
  }),
  methods: {
    async submit () {
      try {
        await deleteUser(this.userData.id)
        this.$buefy.notification.open({
          message: `User <b>${this.userData.username}</b> deleted successfully!`,
          type: 'is-success'
        })
        this.$emit('close')
        this.$emit('submit', this.userData.id)
      } catch (err) {
        this.$buefy.notification.open({
          message: err.message,
          type: 'is-danger'
        })
      }
    }
  }
}
</script>

<style>

</style>
